import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CarCard } from "@/components/CarCard";
import { Button } from "@/components/ui/button";
import { Heart, Loader2 } from "lucide-react";

export default function Favoritos() {
  const navigate = useNavigate();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/favorites").then(({ data }) => setCars(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10" data-testid="favoritos-page">
      <p className="overline text-blaze mb-2 flex items-center gap-2"><Heart className="w-4 h-4 fill-blaze text-blaze" /> Seus favoritos</p>
      <h1 className="font-heading font-800 text-3xl md:text-4xl mb-8">Carros salvos</h1>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blaze" /></div>
      ) : cars.length === 0 ? (
        <div className="bg-white border border-dashed border-border rounded-sm p-16 text-center" data-testid="favoritos-empty">
          <Heart className="w-10 h-10 mx-auto mb-4 text-muted-foreground" strokeWidth={1.5} />
          <p className="text-muted-foreground mb-4">Você ainda não salvou nenhum carro. Toque no coração de um anúncio para acompanhar.</p>
          <Button className="bg-obsidian hover:bg-blaze text-white rounded-sm" onClick={() => navigate("/buscar")} data-testid="favoritos-buscar-btn">Buscar carros</Button>
        </div>
      ) : (
        <>
          <p className="text-sm text-muted-foreground mb-5">Avisamos você por e-mail quando um favorito baixar de preço.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {cars.map((c, i) => <CarCard key={c.id} car={c} index={i} />)}
          </div>
        </>
      )}
    </div>
  );
}
